module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER THREE")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“H")])])]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e’s")]), _vm._v(" got her cell? Who? How?” Michael’s gut constricted. The throbbing in his head increased its tapping against his skull.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t know.” Kyra’s gaze connected with Michael’s. “Who’s this person she’s emailing called skullandcrossbones?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would have said Preston, but he’s dead. I don’t know.” Why didn’t he? He’d tried to forge a bond with Amy, but—He couldn’t think straight with Kyra’s vanilla scent teasing his nostrils. When he’d been growing up, he’d fancied himself in love with Kyra, who thought of him only as Ginny’s kid brother. But what did a boy of fifteen or sixteen really know about love? He didn’t even think he had a good grasp on it now. Not after Sarah. He’d failed her when she’d needed him the most.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe frowned. “Maybe that’s something I could ask her friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me do that. They might talk to me but not the police.” Michael remembered the short list of Amy’s girlfriends he’d called and the fact he’d gotten nowhere with them. They knew something and weren’t talking. But he had to do something to help Amy, and maybe after he "), _c('a', {
    attrs: {
      "id": "page29"
    }
  }), _vm._v("pressed upon them the danger his sister was in, they would open up to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Indecision shadowed the police chief’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He might have a point. I could go with Michael. See if I can figure out who’s lying or telling the truth. I got pretty good at reading people while working as a detective in Dallas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great, I’m glad you’re gonna help me. Our resources are stretched at best on a good day. This isn’t a good day. The officer who has some knowledge about computers is the one on vacation this week. He’s not even in town. That leaves me with only Wilson, Connors and Nichols.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s also something I can help you with, Gabe. It’s a necessity in my job. If it’s okay with you and Michael, I can dig around and see what I can come up with on Amy’s computer.” Kyra peered from the police chief to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her professional facade had descended, but this side of Kyra was just as appealing as the one who had declared she would help him. For months Michael had figured he was in over his head with Amy, but it was official now. Although he was only thirty-three, he felt decades older than his seventeen-year-old kid sister. “I don’t have any problem with that. Chief?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nope. Then that’s settled. I’ll leave it here for you to do whatever you do.” Gabe headed for the door. “I don’t see anything else in here that could help us find Amy.” He paused at the door. “Michael, show me which way she would have come into the house the last time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He panned the room, then joined Gabe in the hallway. “It had to be the back door through the kitchen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s Amy’s cell-phone number?” The police chief trailed behind Michael toward the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael gave it to him and added, “Remember she doesn’t have it with her.” He surveyed the floor for any "), _c('a', {
    attrs: {
      "id": "page30"
    }
  }), _vm._v("red spots on the tile, then when he didn’t see any, he lifted his gaze to take in the rest of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or so she wants us to think. We only have her word that ‘he’ has it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You think she wrote that in the email because she knew she could be tracked by the cell’s GPS?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s possible, but not probable,” Gabe said, followed by a humorless chuckle. “We might be able to track the person who took Amy’s cell if he has it as she said. I’ll get Connors on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Turn the tables on the guy Amy is running from?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ain’t technology great.” Gabe winked and sauntered toward the back door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael certainly hadn’t had time to keep up with all the technology being developed—except in his field of medicine—with his work schedule. He was one of two doctors in a community with a large ratio of elderly people who needed a great deal of medical attention. And before he came back to Flamingo Cay, his life had been a living nightmare for the last year in Chicago. Still was. The image of Sarah at the accident that had taken her life continued to haunt him even after over a year. He hadn’t been able to save her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wasn’t going to lose his sister, too. “How are we going to find Amy? She’s in trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I guess we’ll have to locate Amy the old-fashioned way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We talk to her friends, check places that she goes to, and I know someone who has a bloodhound that’s a pretty good tracker. I’ll give Harvey a call and have him bring Boomer to track Amy’s movements when she left here. Maybe we can locate her that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hunt his sister down like a fugitive? The thought knot"), _c('a', {
    attrs: {
      "id": "page31"
    }
  }), _vm._v("ted his gut into a tight, hard ball. “Whatever you think is best. I just know we need to get to her before the killer does.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can you get me something that she’s worn lately?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure.” Michael made his way back to Amy’s bedroom. When he entered, Kyra peered up at him and smiled. “Find anything?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A few things. She’s gotten a couple of emails from this skullandcrossbones person during the past few weeks, mostly chatter about Preston. Before that nothing. Maybe the person is a new friend. Do you remember her talking about someone she’d befriended recently?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. But then she and I didn’t talk all that much, especially lately. She sulked a lot. When I asked her what was wrong, she denied anything was.” He waved his hand toward the Patterson house. “Obviously that wasn’t true.” He strode to a pile of shirts and shorts lying next to Amy’s empty dirty-clothes hamper. “Gabe is going to try and track her with a dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s good. She’s in danger. She may not think coming in to the police is the best solution to her problem, but it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why wouldn’t she turn herself in to the police?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know. Maybe she will when she has time to stop and think clearly. Right now she is in flight mode.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He grabbed a shirt Amy had worn recently. “If we find her, would you be willing to be her bodyguard? Ginny told me about your company, and if a killer is after Amy, we’ll need the services of a good bodyguard. As Gabe said, he’s understaffed. I know you agreed to help the chief, but Amy’s safety is the most important thing right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She opened her mouth to say something but snapped it closed. Pressing her lips together, she glanced away for a moment then reestablished eye contact. “I don’t normally "), _c('a', {
    attrs: {
      "id": "page32"
    }
  }), _vm._v("act as a bodyguard myself, but yes, I’ll help. I’ll protect her if it comes to that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the first time in a while he didn’t feel so alone dealing with his problems. “Thanks. This is so out of my league. I’m glad you decided to come home this week.” He held up the article of clothing. “I’d better get this to Gabe. Maybe we’ll have Amy home by the end of the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra watched him leave. The expression of hope on his face tore at her composure. She’d been involved with disappearances of teenagers before and so many of them didn’t turn out well. She owed it to Ginny and even Michael to find their sister and then protect her. She couldn’t leave at the end of the week, go back to Dallas and forget what was happening unless there was a resolution to Amy’s troubles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mentally she began making plans to call her secretary, then see if Elizabeth Caulder could cover for her if she was in Flamingo Cay longer than a week. What else did she need to do? A lot of that would depend on what happened with Amy. The thought she wouldn’t be found left Kyra cold in the midst of the summer heat. She would do what she could to make the outcome different.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She clicked on Amy’s icon for trash to see what she’d deleted lately. A blank screen greeted Kyra’s perusal. Amy had emptied her trash. It would take her a little longer, but files weren’t completely deleted off the computer until there was no more space and a file was written over a trashed one.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Later that morning, Kyra found Michael on the deck facing the Gulf. The blue water glittered as though thousands of shards of crystal had been strewn over its surface. “I didn’t know how much I misssed this until I came home.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page33"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gripping the railing, Michael hunched his shoulders and leaned farther into it. “I know that’s the way I felt when I came back here.” His look didn’t stray from the stretch of sea no more than a hundred yards away. “I remember once when I was twelve and found an old dinghy. I worked all summer to get it in shape. I had planned to go all the way to Key West in it.” He slid her a smile that vanished in a second. “I didn’t make it more than twenty or so feet offshore before I began to sink. I hadn’t repaired all the holes in the bottom, at least not well enough that they didn’t leak. That boat might still be out there somewhere.” He pointed in the direction of where it had gone down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She came up next to him, fighting the urge to cover his hand on the railing with hers. The wistful tone in his voice made her ache for a time when they hadn’t had any real worries. “You haven’t swum out there to see it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. When I got here, I hit the ground running and haven’t stopped since. My partner and I are very busy.” A deep sigh escaped his lips. “I should know what was going on with Amy, too. I feel like I’ve let her down, and now she’s in trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This time she did touch his upper arm, drawing his full attention. Although her gesture was an act of comfort, she felt strange because she found herself attracted to a man who was a good friend’s kid brother—one she had dealt with as a young teenage boy with a crush on her. “Ginny was having problems with Amy. She hit sixteen, and according to your sister, Amy changed overnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shifted toward her, her hand dropping to her side. “Did you find anything on her computer to help find her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The name on the email account of skullandcrossbones is a Kip Thomas. Do you know someone by that name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page34"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve asked Gabe to see what he can find out about this person who supposedly lives in Naples. It could be a fake name and address. That’s not hard to do when setting up an email account.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good. Anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A journal she kept up until ten days ago. She deleted it, but I was able to recover it. Did something happen at that time?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A faraway look darkened his blue eyes to a storm. “That’s when I grounded her for coming in two hours late from a date. She’d just gotten off from being grounded a few days ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who did she go out with?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She told me Brady Lawson, a guy she used to date during the school year, but I’m pretty sure it was Preston. I didn’t see the car she came home in, but I heard it. It sounded like Preston’s GTO. Lately she has been going out with Preston, and she knew I didn’t think he was the right kind of guy for her.” He rotated around and sat back on the railing, folding his arms over his chest. “Did you read the journal?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, a lot of angst. Brady and she broke up two months ago, then she met another guy she thought was hot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did she say who?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. She called him Hottie. Apparently they spent time in the swamp, partying.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That Preston.” His features strengthened into a scowl. “But I don’t know for sure and that’s the problem.” A nerve twitched in his cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She talked a lot about a girl named Laurie. Do you know her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Laurie and Amy were BFFs, or so she told me on a number of occasions.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then I suggest we go talk to her best friend first.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page35"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, after Gabe searches the area with the bloodhound. I figure you’ll want to be here in case he turns up anything useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. Maybe the dog will find Amy’s trail and lead us right to her.” Hope flared in his expression for a few seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If nothing is found to help us, we can go talk to Laurie. She might know something about where Amy would go if she was afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Frankly the place I would say she would go was Laurie’s, but when I called earlier no one answered the phone.” Michael shuddered, his shoulders drooping. “This is a peaceful little town. A kid shouldn’t have to be afraid for her life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, but sadly that’s not the way it is in this world.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, there are two dead young men to prove that. I saw my fair share of gunshot victims in the emergency room in Chicago. Some were caught up in gang wars. Others in drug deals gone bad. I thought I had left that behind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As a police officer, I discovered evil can exist anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wilson told me he didn’t know who the other victim at the Pattersons’ house was. He appeared older than Preston. Do you think this has anything to do with drugs or something like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe. When I talked to Gabe a few minutes ago, he told me the other person who died at the scene was Preston’s cousin from Miami, Tyler Stevens. His cousin had been visiting and hadn’t been here long. He had the same black dagger tattooed on his neck as Preston did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A gang?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gabe is checking with the Miami police. “")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page36"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pushed away from the railing. “I never thought of Flamingo Cay and gangs in the same context.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He said they checked where the man I chased ran into the undergrowth and saw another set of prints near his and mine. Looked to be about a size-thirteen shoe, Gabe said. Since it rained last night, he thinks either someone was standing there watching the house or waiting for Amy or someone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A gray tinge to his face, Michael sucked in a shaky breath then slowly released it. “Let’s see what progress Harvey and his bloodhound, Boomer, have made. Maybe they’ve already found a trail that will lead us right to Amy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra hoped so, too, but what she wouldn’t voice to Michael was her concern over how they would find Amy. When his gaze snagged hers as he moved toward his back door, though, she glimpsed the same fear in his expression as she had. Amy could be dead somewhere nearby. Like the two young men at the Pattersons’.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She halted Michael’s progress into his house with, “Amy came back and changed. She was alive a while ago and got away from whoever killed those boys because I chased him to the canal in the opposite direction from here. I don’t think she had time to come home, change and somehow end up in the swamp being chased by the assailant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pain glazed his eyes. “Yeah, but what if the second person Gabe found the prints of followed her here and waited until she left again?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“With all the police around here? Probably not.” At least she prayed he hadn’t. Kyra grabbed her damp tennis shoes and put them on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frowning, Michael yanked open the back door and strode through the entrance and continued toward the "), _c('a', {
    attrs: {
      "id": "page37"
    }
  }), _vm._v("foyer. When he stepped outside onto the porch, he peered toward the Pattersons’ house. A red, beat-up truck was parked behind a police cruiser in the driveway. “Where’s Gabe? Harvey?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The need to let him know he wasn’t alone inundated her. This was someone she’d grown up with, and she’d been at his house playing with his older sister. “It looks like Gabe has already started tracking Amy’s movements.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael turned to the left in the direction Kyra indicated. Gabe ambled across the next-door neighbor’s yard, slightly behind a large man with a barrel chest and a bloodhound in the lead. “I’m not ready for this.” His voice caught on the last word as his fingers grasped the railing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra clasped his arm, wishing she’d been able to prevent Amy from running away this morning at the Pattersons’. But if Amy had stopped, the killer would have shot her in the back. “Remember I’m here for you. We’ll find her, and I’ll make sure she’s safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pried loose his grip from the railing and peered toward her. “I appreciate your help. I’ve never had something like this happen to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was all too familiar with a person agonizing over the disappearance of a loved one. “Most people thankfully don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Flamingo Cay is a small town. Things like this don’t happen here. I know that Gabe has been the police chief for twenty-three years, but is he capable of handling these multiple murders?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know for a fact he can. When I was thirteen, there had been a family murdered here not far outside of town. He wasn’t the police chief yet, but he’s the one who solved the case and brought the man in. A fine piece of detective work. He and Dad were friends. He used to come over, "), _c('a', {
    attrs: {
      "id": "page38"
    }
  }), _vm._v("and I would overhear the details about the case. Of course, they didn’t know I was listening. But that’s when I started wanting to be a police officer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That must have been right before we moved to Flamingo Cay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, if I remember correctly you all moved in a couple of months after that case was solved.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Still, I’m glad you’re helping him with the case. Ginny told me about some of the murders you worked on in Dallas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The idea he and Ginny had talked about her warmed her face. Yes, she’d talked about Michael with Ginny, but she had also discussed Amy. A friend curious about a friend’s family.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shoved away from the railing and descended the steps. “I wonder if he’s checked the swamp area behind the Pattersons’ place.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He probably will after he finds Amy’s trail. I didn’t see anything while I was in the swamp that would point to who the killer is, but then I was ducking bullets.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael clamped his jaw tightly, his neck stiff. “You make it sound like it was no big deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is a big deal, but I refuse to let it get to me or I’ll hesitate when I shouldn’t.” She descended the front steps. “You said Amy loves the swamp. Any particular place she liked to go?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She had a kayak she kept sometimes at the old pier at the end of the trail, but usually at the public dock off Main. She asked me about a few places, but I never heard about one area she spent all her time. She gave me some story that she needed to help preserve places like the Everglades and that she liked moving around.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t you think she meant it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There was something in her tone. A certain look on "), _c('a', {
    attrs: {
      "id": "page39"
    }
  }), _vm._v("her face. She kept her gaze averted. Just a feeling.” He headed across the yard toward Gabe and Harvey.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The police chief came to a halt at the curb in front of Michael’s house and removed a toothpick from his mouth. “We followed a trail across several neighbors’ yards until it reached the middle of Bay Shore Drive and suddenly ended like someone had picked her up in a car. I’ve called Nichols and Connors to check with friends and to begin a search of the town. What was she doing yesterday? Who was she with?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Amy loves spending time in the marshes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So she spent most of yesterday in the swamp?” Gabe rolled the toothpick between his thumb and forefinger as he started toward the Pattersons’ house. “Alone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She never mentioned anyone, but I think Laurie sometimes went with her.” Michael pointed toward the thick cluster of trees edging the undergrowth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they came closer to the border of the swamp, Harvey quickened his pace, following behind his bloodhound. They entered where the killer had when Kyra went after him, not on the well-worn path ten yards away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s see where Boomer takes us. Since it’s summer there’s a lot of water.” Gabe peered at Kyra’s tennis shoes. “You might want to wear something else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t have anything else. And as you can see, I’ve been in mud up to my ankles. Don’t worry about me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Harvey directed Boomer into the underbrush with Gabe trailing next, then Kyra and Michael. With nose to the ground, the bloodhound took off, charging through the vegetation in the same direction Kyra had gone only hours ago after the assailant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They emerged from the undergrowth onto the path, and Michael fell in right behind her. “When I was a child, I use to come here like Amy. Loved the adventure. That’s "), _c('a', {
    attrs: {
      "id": "page40"
    }
  }), _vm._v("why I really couldn’t say much to Amy about coming here alone. But I’ve been back for four months and have only gone into the swamp a few times.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Things change when we grow up. I can’t say I liked exploring the swamp when I was a child.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One corner of his mouth tilted up. “And now all of a sudden you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rotting smell of vegetation coupled with the incessant noise of insects brought back childhood memories. “Maybe I should amend my earlier statement. Some things change. That isn’t one of them. I prefer pursuing an adventure somewhere else. At the moment somewhere air-conditioned.” Beads of perspiration rolled down Kyra’s face, blurring her vision for a second until she blinked to clear it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael swiped a hand across his damp forehead. “I haven’t gotten used to the humidity yet either, and it’s been four months.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Boomer approached the short pier, the dog lumbered over the wooden planks, some broken and missing, going back and forth from one side to the other until he reached the end. The bloodhound stopped and sat, looking up at Harvey as if to say this was as far as he would go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good boy.” Harvey scratched behind Boomer’s ears.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael went to the edge and leaned over. “Amy’s kayak isn’t here so she must have it at the town dock.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One-or two-man?” With her hand shielding her eyes, Kyra scanned the open waterway that stretched across a few hundred yards to more tangled vegetation, one mangrove island after another. Where did the killer go? Who was the second man? Why had the man killed Preston and Tyler?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two, like my kayak I keep there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll have Wilson check to see if her kayak is at the "), _c('a', {
    attrs: {
      "id": "page41"
    }
  }), _vm._v("dock. Someone could have given her a ride there. If it’s gone, then we’ll need to search the swamp for Amy.” Gabe dropped the chewed-up toothpick into the top pocket of his shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Harvey took off his beat-up straw hat and mopped his face with a handkerchief, then stuffed it back into his jeans. “I’ll have Boomer check around the pier and see if he can come up with anything else.” Harvey plopped his hat back on his head and indicated to Boomer to get up. “Then we’ll head back along the path.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So this was a waste of time.” What had Amy gotten caught up in? Michael went back over the past few days in his head, trying to remember anything she might have said to him to help them find her. He’d been gone a lot because his partner had been on vacation. Thankfully his partner had got back yesterday evening and could fill in for Michael this morning at the clinic. But that consolation didn’t give him the answers he needed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, not totally. We know wherever Amy went she used a car most likely. Yeah, it would have been nice to have Boomer lead us to her.” Gabe waved his hand toward Harvey and his dog beginning their trip back to Pelican Lane. “I’m heading to the station. We need to expand our search of the town and see if Amy’s kayak is at the public pier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael stared at the canal gently flowing past the old pier. The water’s smooth surface—like a mirror—reflected the nearby trees in it. A breeze blew the scent of overripe, damp vegetation to his nostrils. Every shade of green from a light yellowish tint to a dark vibrant one met his inspection of the terrain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Amy, where are you? Are you safe?")]), _vm._v(" In the past he would have prayed to the Lord, but for months he’d been silent. "), _c('a', {
    attrs: {
      "id": "page42"
    }
  }), _vm._v("He pivoted to go back and nearly collided with Kyra behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His hand shot out to steady her. Automatically he brought her closer, her feminine scent driving the aromas of the swamp into the background and totally centering his focus on the beautiful woman with her auburn hair pulled back from her face. That only emphasized her large eyes, a golden-brown like dark honey. “I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She chuckled. “The last place I’d want to end up is in that water.” Her gaze shifted to a hole in the plank at the canal below. “I wasn’t like you and Amy. I didn’t go exploring much. Put me in the rough section of a town at night, and I’d feel more comfortable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A shiver flowed from her, through his hands and up his arms, making him acutely aware that his teenage fantasy girl was standing before him. His attention latched on to her mouth, so close that his long-ago dreams of kissing Kyra overwhelmed him. Throwing him completely off guard. He stepped back, the heel of one foot coming down a couple of inches over the end of the pier.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He teetered a few seconds. She reached out to catch him before he went into the water. He managed to regain his balance and sidled away before he made a total fool of himself. He’d been serious about Sarah in Chicago. They had planned to marry until a man fell asleep at the wheel of his car and had hit them. Despite his injuries, Michael had tried to save Sarah, but all his medical knowledge hadn’t kept her from slipping away from him only minutes after he’d manage to get to her in the wrecked car. The pain in her eyes, the last shuddering breath she’d taken still tormented him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good recovery.” Her beautiful mouth formed a heart-melting smile that touched a coldness he’d been encased in for over a year.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page43"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s leave before we both end up in the water.” He allowed her to go first toward the path that led through the grove of trees. “I remember when this pier was in good shape and used by a lot of the neighbors on Pelican Lane. But a couple of hurricanes have taken their toll on it. I think Amy is one of the few who still use it from time to time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Has much else changed about the town?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Its population has grown to three thousand. Other than that, no.” But then he hadn’t really paid a lot of attention. He’d thrown himself into his new job, relieved that the pace was a bit slower than a Chicago hospital but enough that he didn’t dwell on his past. He’d needed that. Or so he thought. Maybe his emotional distancing had brought all this on. The pace might have been slower, but it hadn’t stopped him from working long hours rather than face his feelings head-on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Harvey, Gabe and Boomer stood off the trail near the edge of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra approached them. “What did the dog find?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Several cigarette butts.” Gabe took out an evidence bag, stooped and eased the filter ends into the small manila envelope. “May be nothing. May be important.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Standing, he studied the ground around him a long moment, then ambled behind Boomer and Harvey. The bloodhound went to the side deck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s probably the way the assailant went into the house,” Kyra said while the trio made their way to Gabe’s patrol car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“By the time DNA testing comes back on the cigarette butts, Amy could be dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It can take a while even with a rush on it, but it could help make a case against the guy when he is found.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That might be too late for my sister.” When Michael "), _c('a', {
    attrs: {
      "id": "page44"
    }
  }), _vm._v("emerged from the undergrowth onto the road near the Pattersons’ house, he saw Gabe on his cell. Harvey was pulling away in his old pickup truck with Boomer in the back, looking at Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Officer Connors just called to tell me he’s checked all Amy’s usual haunts and found nothing. No one has seen her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How about Laurie?” Kyra asked, looking down at her muddy tennis shoes for the second time that day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Connors said no one answered when he called her house about an hour ago. He even drove by and didn’t see Mrs. Carson’s white Chevy out front. Since she works evenings, he thought she might be there and was sleeping or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If anyone knows where Amy is it would be Laurie. Where one goes the other usually isn’t far behind.” Michael stuffed his hands into his front jean pockets, his shoulders slumping forward. He needed to do something. He couldn’t sit around and just wait. He’d never been good at doing that. He looked for solutions to problems and carried them out—or at least he had until he hit an emotional wall with Sarah’s death. “What can I do to help?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gabe, maybe Michael and I could go to Laurie’s and see if she or her mother are home yet. That way you can use all your men for the search.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine. As I told you before, I can use any help I can get. Call if you find out anything.” Gabe opened his car door and climbed inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will.” The sun’s rays tinted Kyra’s cheeks a rosy color.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You said something about expanding the search. Are you going to search the swamp?” Michael glimpsed a patrol car coming down the street.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I haven’t heard back from Wilson yet. If Amy’s kayak "), _c('a', {
    attrs: {
      "id": "page45"
    }
  }), _vm._v("is gone at the Main Street dock, yes. If not, we should concentrate on the town and the surrounding area. Since someone most likely picked her up in a car, that’s probably how she’s traveling.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Laurie has a car. Amy’s Camry is still in the garage.” He prayed it was Laurie who had come and picked Amy up. The alternative could mean his sister was dead like the two young men.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If Laurie isn’t there, at least check with Mrs. Carson to see if her car is gone.” Gabe kneaded the cords of his neck. “Or look into the garage. If I remember correctly, there’s a window that allows you to see inside. But you didn’t hear that from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra chuckled. “I never heard a word.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael kept thinking about the swamp, the lure of the slow-moving water. “What if she didn’t use her kayak but someone else’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll explore the swamp even if her kayak is at the dock, but that kind of search requires a lot of manpower and coordination. I couldn’t get it together before dark. If nothing turns up, we’ll start tomorrow morning. I’ll put the call in to the sheriff’s department about the possibility. Maybe they can spare a few people to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine,” Michael said between gritted teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe ambled over to Nichols, who had parked and was getting out of his car. The police chief spoke to his officer, then the young man got back in the cruiser and left. Gabe took his cell out and made a call.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael pulled out his car keys. “I’ll drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe I should wash my shoes again or change.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t worry. I’ll clean the car after this is all over with.” He pointed down at his boots. “I feel like the clock is ticking on this.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page46"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine, I understand.” Kyra slipped into his car as he did. “Is it just Laurie and her mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Laurie lives with only her mother. If Laurie is anything like Amy in the summer, she’s sleeping in. Usually Amy isn’t up until ten or eleven.” He started the Saturn’s engine. Before backing out, he twisted toward Kyra. “Should I call Laurie first? See if she’s there. It could be a wasted trip, like Officer Connors’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. If she’s home, I’d like to see her reaction when she finds out about Amy going missing. I might be able to tell if she knows anything and isn’t saying.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a926d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter-03.vue
// module id = 75
// module chunks = 0